import {Component, computed, inject} from '@angular/core';
import {LoaderService} from '../../../services/loader.service';

@Component({
  selector: 'component-loading',
  imports: [],
  templateUrl: './component-loading.component.html',
  styleUrl: './component-loading.component.scss'
})
export class ComponentLoading {

  loaderService: LoaderService = inject(LoaderService);

  readonly visible = computed(() => this.loaderService.count() > 0);

}
